import { NumericRangeFilterOption } from '../types';
import { NumericRange } from '../../components';

export const config: NumericRangeFilterOption = {
  id: 'omicsExplorer.filters.rnaExpression',
  title: {
    id: 'omicsExplorer.filters.rnaExpression',
    defaultMessage: 'Expression',
  },
  content: NumericRange,
  injectedProps: {
    id: 'expression',
    step: 1.0,
    searchKey: 'expression',
    buttonIntlLabel: {
      id: 'omicsExplorer.filters.rnaExpression.button.placeholder',
      defaultMessage: 'Add Filter',
    },
    maxHelpMessage: {
      id: 'omicsExplorer.filters.rnaExpression.maxHelpMessage',
      defaultMessage: '<= Max',
    },
    minHelpMessage: {
      id: 'omicsExplorer.filters.rnaExpression.minHelpMessage',
      defaultMessage: '>= Min',
    },
  },
};
